<template>

	<vxe-modal size="mini" v-model="model" width="1200" height="500" :show-footer="false" destroy-on-close @show="show"
		@hide="hide" transfer :lock-scroll="false" :showHeader="true" :loading="loading" title="快递查询">
		<template #default>
			<el-form ref="form" :inline="true" size="mini" :model="form" label-width="80px">
				<el-form-item label="省份">
					<emun name="city" :emptyoption="false" v-model="form.target" />
				</el-form-item>
				<el-form-item label="快递公司">
					<el-input v-model="form.distrParamName" />
				</el-form-item>
				<el-form-item label="ERP净重(不含包装物资)" label-width="150px">
					<el-input-number controls-position="right" v-model="form.weight" :precision="2" :step="0.1">
					</el-input-number>
				</el-form-item>
				<el-form-item label="仓库">
					<el-select v-model="form.warehouse" placeholder="" filterable>
						<el-option v-for="item in storageOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>					
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="checkparcel">查询</el-button>
				</el-form-item>
			</el-form>
			<vxe-table :data="tableData" height="300" size="mini" border>
				<vxe-column type="seq" width="60"></vxe-column>
				<vxe-column field="distrParamName" title="快递公司名称"></vxe-column>
				<vxe-column field="distrName" title="快递名称"></vxe-column>
				<vxe-column field="storageName" title="推荐仓库"></vxe-column>
				<vxe-column field="targettPrice" title="价格"></vxe-column>
				<vxe-column field="weight" title="毛重"></vxe-column>
			</vxe-table>
		</template>
	</vxe-modal>
</template>
<style>

</style>
<script>
	import emun from '@_system/components/formcomponents/common/select/emun/select.vue'
	export default {
		props: {
			windowType: {
				type: String,
				default: () => {
					return 'modal'
				}
			}

		},
		data() {
			return {
				loading: false,
				model: true,
				storageOptions:[],
				form: {
					weight: 0,
					distrParamName:null,
					target: null,
					warehouse: null
				},
				tableData: [],
				// tableData: [{
				// 		id: 10001,
				// 		name: 'Test1',
				// 		role: 'Develop',
				// 		sex: 'Man',
				// 		age: 28,
				// 		address: 'test abc'
				// 	},
				// 	{
				// 		id: 10002,
				// 		name: 'Test2',
				// 		role: 'Test',
				// 		sex: 'Women',
				// 		age: 22,
				// 		address: 'Guangzhou'
				// 	},
				// 	{
				// 		id: 10003,
				// 		name: 'Test3',
				// 		role: 'PM',
				// 		sex: 'Man',
				// 		age: 32,
				// 		address: 'Shanghai'
				// 	},
				// 	{
				// 		id: 10004,
				// 		name: 'Test4',
				// 		role: 'Designer',
				// 		sex: 'Women',
				// 		age: 24,
				// 		address: 'Shanghai'
				// 	}
				// ]
			}

		},

		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},

		methods: {
			show() {
				this.$api.parcel.getformconfig().then((res) => {
					let storageOptions = []
					res.storage.forEach((item)=>{
						storageOptions.push({
							label:item,
							value:item,
						})
					})
					this.storageOptions = storageOptions
					console.log(res)
				})
			},
			hide() {
				this.$emit('hide')
			},
			checkparcel() {
				this.$api.parcel.listCheck(this.form).then((res) => {
					this.tableData = res
				})
			}
		},
		components: {
			emun,

		}
	}
</script>